interface TTenantTreeCompany {
  deleted: boolean;
  name: string;
  logo: string;
  id: string;
  productPackagePlanIds: string[];
  status: number;
  projects: [];
  tenantId: string;
}

export interface ITenantTree {
  companies: TTenantTreeCompany[];
  name: string;
  logo: string;
  id: string;
  productPackagePlanIds: string[];
  status: number;
}

export class CoreTenantTreeModel {
  label: string;
  value: string;
  children!: CoreTenantTreeModel[];
  info: ITenantTree;

  constructor(data: ITenantTree) {
    this.info = data;
    this.label = data.name;
    this.value = data.id;
    if (data.companies && data.companies.length) {
      this.children = data.companies
        .map((i: any) => new CoreTenantTreeModel(i))
        .sort((a, b) =>
          a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1,
        )
        .filter((company) => company.info.name != data.name);
    }
  }
}

export interface CoreTenantInfo {
  code: string;
  name: string;
  logo: string;
  logoName: string;
  registrationNo: string;
  tenantCompanyId: string;
  timezoneId: string;
  timezone: any;
  timeZoneName: string;
  languageId: string;
  language: any;
  languageName: string;
  formatId: string;
  regionalFormat: any;
  regionalFormatname: string;
  contactIds: any[];
  listContacts: any[];
  productPackagePlanIds: string[];
  listProductPackagePlan: any[];
  listTenantAdmins: any[];
  id: string;
  deleted: boolean;
  createdBy: string;
  createdDate: Date;
  modifiedBy: string;
  modifiedDate: Date;
  status: number;
  statusName: string;
}
